// Shared by the feature/USP lists on ProductCard and CollectionProductCard so
// both render the same mark.
const CheckCircleIcon = ({ className = 'shrink-0' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.83891 16.5543C12.9234 16.5543 15.4239 14.0538 15.4239 10.9693C15.4239 7.88477 12.9234 5.38428 9.83891 5.38428C6.7544 5.38428 4.25391 7.88477 4.25391 10.9693C4.25391 14.0538 6.7544 16.5543 9.83891 16.5543ZM9.07637 13.7615L9.09227 13.7618C9.24261 13.7618 9.38704 13.7022 9.49367 13.5954L12.5468 9.61136C12.7686 9.3897 12.7686 9.0302 12.5468 8.80843C12.3253 8.58678 11.9655 8.58678 11.744 8.80843L9.11532 12.3678L8.03749 11.1618C7.82855 10.928 7.46961 10.9077 7.23581 11.1168C7.00201 11.3258 6.98191 11.6847 7.19085 11.9185L8.66895 13.5724C8.77296 13.6887 8.92023 13.7571 9.07637 13.7615Z"
      fill="#00513E"
    />
  </svg>
);

export default CheckCircleIcon;
